import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  problemEditorTypeSingleSelectTitle: {
    id: 'authoring.problemeditor.settings.problemtype.singleselect.title',
    defaultMessage: 'Single select',
    description: 'Title of the single select editor',
  },
  problemEditorTypeMultiSelectTitle: {
    id: 'authoring.problemeditor.settings.problemtype.multiselect.title',
    defaultMessage: 'Multi-select',
    description: 'Title of the multi select editor',
  },
  problemEditorTypeDropDownTitle: {
    id: 'authoring.problemeditor.settings.problemtype.dropdown.title',
    defaultMessage: 'Dropdown',
    description: 'Title of the dropdown editor',
  },
  problemEditorTypeNumericTitle: {
    id: 'authoring.problemeditor.settings.problemtype.numeric.title',
    defaultMessage: 'Numerical input',
    description: 'Title of the numerical input editor',
  },
  problemEditorTypeTextInputTitle: {
    id: 'authoring.problemeditor.settings.problemtype.textinput.title',
    defaultMessage: 'Text input',
    description: 'Title of the text input editor',
  },
  problemEditorTypeAdvancedTitle: {
    id: 'authoring.problemeditor.settings.problemtype.advanced.title',
    defaultMessage: 'Advanced Problem',
    description: 'Title of the advanced problem editor',
  },
  problemEditorTypeSingleSelectDescription: {
    id: 'authoring.problemeditor.settings.problemtype.singleselect.description',
    defaultMessage: 'Enter your single select answers below and select which choices are correct. Learners must choose one correct answer.',
    description: 'Description of the single select editor',
  },
  problemEditorTypeMultiSelectDescription: {
    id: 'authoring.problemeditor.settings.problemtype.multiselect.description',
    defaultMessage: 'Enter your multi select answers below and select which choices are correct. Learners must choose all correct answers.',
    description: 'Description of the multi select editor',
  },
  problemEditorTypeDropDownDescription: {
    id: 'authoring.problemeditor.settings.problemtype.dropdown.description',
    defaultMessage: 'Enter your dropdown answers below and select which choice is correct. Learners must select one correct answer.',
    description: 'Description of the dropdown editor',
  },
  problemEditorTypeNumericDescription: {
    id: 'authoring.problemeditor.settings.problemtype.numeric.description',
    defaultMessage: 'Enter correct numerical input answers below. Learners must enter one correct answer.',
    description: 'Description of the numerical input editor',
  },
  problemEditorTypeTextInputDescription: {
    id: 'authoring.problemeditor.settings.problemtype.textinput.description',
    defaultMessage: 'Enter your text input answers below and select which choices are correct. Learners must enter one correct answer.',
    description: 'Description of the text input editor',
  },
  problemEditorTypeAdvancedDescription: {
    id: 'authoring.problemeditor.settings.problemtype.advanced.description',
    defaultMessage: 'An Advanced Problem Type',
    description: 'Description of the advanced problem editor',
  },
  problemEditorTypeSingleSelectPreviewDescription: {
    id: 'authoring.problemeditor.settings.problemtype.singleselect.previewdescription',
    defaultMessage: 'Learners must select the correct answer from a list of possible options.',
    description: 'Preview description of the single select editor',
  },
  problemEditorTypeMultiSelectPreviewDescription: {
    id: 'authoring.problemeditor.settings.problemtype.multiselect.previewdescription',
    defaultMessage: 'Learners must select all correct answers from a list of possible options.',
    description: 'Preview description of the multi select editor',
  },
  problemEditorTypeDropDownPreviewDescription: {
    id: 'authoring.problemeditor.settings.problemtype.dropdown.previewdescription',
    defaultMessage: 'Learners must select the correct answer from a list of possible options',
    description: 'Preview description of the dropdown editor',
  },
  problemEditorTypeNumericPreviewDescription: {
    id: 'authoring.problemeditor.settings.problemtype.numeric.previewdescription',
    defaultMessage: 'Specify one or more correct numeric answers, submitted in a response field.',
    description: 'Preview description of the numerical input editor',
  },
  problemEditorTypeTextInputPreviewDescription: {
    id: 'authoring.problemeditor.settings.problemtype.textinput.previewdescription',
    defaultMessage: 'Specify one or more correct text answers, including numbers and special characters, submitted in a response field.',
    description: 'Preview description of the text input editor',
  },
  problemEditorTypeAdvancedProbemsStatusEmpty: {
    id: 'authoring.problemeditor.settings.problemtype.advanced.status.empty',
    defaultMessage: '',
    description: 'Empty status of the advanced problem editor',
  },
  problemEditorTypeAdvancedProbemsStatusNotSupported: {
    id: 'authoring.problemeditor.settings.problemtype.advanced.status.notsupported',
    defaultMessage: 'Not supported',
    description: 'Status of the advanced problem editor',
  },
  problemEditorTypeAdvancedProbemsStatusProvisional: {
    id: 'authoring.problemeditor.settings.problemtype.advanced.status.provisional',
    defaultMessage: 'Provisional',
    description: 'Status of the advanced problem editor',
  },
  problemEditorTypeAdvancedProbemsBlankTitle: {
    id: 'authoring.problemeditor.settings.problemtype.advanced.blank.title',
    defaultMessage: 'Blank problem',
    description: 'Title of the blank problem editor',
  },
  problemEditorTypeAdvancedProbemsCircuitSchematicTitle: {
    id: 'authoring.problemeditor.settings.problemtype.advanced.circuitschematic.title',
    defaultMessage: 'Circuit schematic builder',
    description: 'Title of the circuit schematic problem editor',
  },
  problemEditorTypeAdvancedProbemsJsInputTitle: {
    id: 'authoring.problemeditor.settings.problemtype.advanced.jsinput.title',
    defaultMessage: 'Custom JavaScript display and grading',
    description: 'Title of the custom JavaScript display and grading problem editor',
  },
  problemEditorTypeAdvancedProbemsCustomGraderTitle: {
    id: 'authoring.problemeditor.settings.problemtype.advanced.customgrader.title',
    defaultMessage: 'Custom Python-evaluated input',
    description: 'Title of the custom Python-evaluated input problem editor',
  },
  problemEditorTypeAdvancedProbemsImageMappedTitle: {
    id: 'authoring.problemeditor.settings.problemtype.advanced.imagemapped.title',
    defaultMessage: 'Image mapped input',
    description: 'Title of the image mapped input problem editor',
  },
  problemEditorTypeAdvancedProbemsFormulaTitle: {
    id: 'authoring.problemeditor.settings.problemtype.advanced.formula.title',
    defaultMessage: 'Math expression input',
    description: 'Title of the math expression input problem editor',
  },
  problemEditorTypeAdvancedProbemsProblemWithHintTitle: {
    id: 'authoring.problemeditor.settings.problemtype.advanced.problemwithhint.title',
    defaultMessage: 'Problem with adaptive hint',
    description: 'Title of the problem with adaptive hint problem editor',
  },
});

export default messages;
